import { Button } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { customButtonTheme } from 'assets/styles/themes/generic_button_mui';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { importCsvDataMetaculture } from 'services/API/Cooperative';
import { displayErrorMessage, formatFileSize } from 'utils/tools_functions';

const Import = () => {
  const { t } = useTranslation();
  const [file, setFile] = useState<File | null | undefined>(null);

  const importDataFromFile = () => {
    let formData = new FormData();
    formData.append('file', file as File);
    importCsvDataMetaculture(formData)
      .then(() => {
        toast.success(t('success.fileImported', { filename: file?.name }));
      })
      .catch((error) => {
        console.log(error);
        toast.error(displayErrorMessage('ERR_IMPORT_CSV'));
      });
  };

  return (
    <div>
      <h1 className="title_section">{t('title.importMetacultures')}</h1>
      {file ? (
        <div className="wrapper-import">
          <div className="wrapper-import__infos">
            <div>
              {t('label.fileName')} :{' '}
              <span className="wrapper-import__infos__detail">{file.name} </span>
            </div>
            <div>
              <span>
                {t('label.fileSize')} :{' '}
                <span className="wrapper-import__infos__detail">{formatFileSize(file.size)}</span>
              </span>
            </div>
          </div>
          <ThemeProvider theme={customButtonTheme}>
            <div>
              <div className="wrapper-import__button">
                <Button onClick={() => importDataFromFile()}>{t('button.importData')}</Button>
              </div>
              <div className="wrapper-import__button">
                <Button onClick={() => setFile(null)}>{t('button.importNewFile')}</Button>
              </div>
            </div>
          </ThemeProvider>
        </div>
      ) : (
        <div>
          <input type="file" accept="text/csv" onChange={(e) => setFile(e?.target?.files?.[0])} />
        </div>
      )}
    </div>
  );
};

export default Import;
